import React from 'react';

const IconPaper = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-book-open">
    <title>Paper</title>
    <path d="M12 7v14" />
    <path d="M3 18a1 1 0 0 1 1-1h4a4 4 0 0 1 4 4" />
    <path d="M21 18a1 1 0 0 0-1-1h-4a4 4 0 0 0-4 4" />
    <path d="M12 7a4 4 0 0 0-4-4H4a1 1 0 0 0-1 1v14" />
    <path d="M12 7a4 4 0 0 1 4-4h4a1 1 0 0 1 1 1v14" />
  </svg>
);

export default IconPaper;
